import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { when } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment-timezone';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup, Col, Row } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import { IList } from 'src/Components/DataTable/DataTable';
import { IDispatchList } from 'src/Interfaces/DispatchInterface';
import { IProduct, ITestApproval } from 'src/Interfaces/TestInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { DispatchStore } from 'src/Stores/Dispatch/DispatchStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import { DispatchListTable } from '../Dispatch/DispatchListTable/DispatchListTable';

export class IApprovalProduct extends IProduct {
    public createDate: string = '';
    public createdBy: string = '';
}

@inject('stores')
@observer
export default class Approval extends React.Component{
    public props: any;
    private testsStore: TestsStore;
    private UserStore: UserStore;
    private AdminStore: AdminStore;
    private DispatchStore: DispatchStore;
    private TenantStore: TenantStore;
    private MessageStore: MessageStore;

    private timeOutDisposer: any;
    public state = {
        approvalList: [] as ITestApproval[],
        productApprovalList: [] as IApprovalProduct[],
        showApprovals: {
            dispatches: true,
            products: true,
            tests: true,
        }
    };

    constructor(props: any) {
        super(props);
        this.testsStore = this.props.stores.TestsStore;
        this.UserStore = this.props.stores.UserStore;
        this.AdminStore = this.props.stores.AdminStore;
        this.DispatchStore = this.props.stores.DispatchStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.MessageStore = this.props.stores.MessageStore;
    }

    public componentDidMount() {
        this.refreshAllList();
        this.timeOutDisposer = setInterval(() => {
            this.refreshAllList();
        }, 300000);
    }

    public componentWillUnmount() {
        clearInterval(this.timeOutDisposer);
    }

    private toggleApproval = (field: string) => () => {
        const showApprovals = this.state.showApprovals;
        showApprovals[field] = !showApprovals[field];
        this.setState({
            showApprovals
        });
    }


    private refreshList = () => {
        this.testsStore.getTestsForApproval()
            .then((approvalList: ITestApproval[]) => {
                if (approvalList) {

                    this.setState({
                        approvalList
                    });
                }
            });
    }

    private refreshAllList() {
        this.refreshList();
        this.refreshProductList();
        this.refreshDispatchList();
    }

    private refreshDispatchList = () => {
        this.DispatchStore.getDispatches();
    }

    private refreshProductList = () => {
        when(() => this.UserStore.user !== undefined).then(() => {
            this.AdminStore.getAllProductsForApproval()
            .then(productApprovalList => {
                if (productApprovalList) {
                    this.setState({
                        productApprovalList
                    });
                }
            });
        });
    }

    private filterNeedsApproval = (value: IDispatchList) => {
        return value.dispatchStatus === "Submitted"
            || value.dispatchStatus === "Updated"
            || value.dispatchStatus === "Rejected";
    }

    private mapShowApproval = (item: IDispatchList) => {
        const hasApproveAll = this.UserStore.hasPermission('Permissions.Dispatch.Approve.All');
        if (hasApproveAll) {
            return true;
        }
        const hasApproveAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Approve.Assigned');
        if (hasApproveAssigned) {
            const sourceWellIds = item.sourceWell && item.sourceWell.engineerIds ? item.sourceWell.engineerIds : [];
            const destWellIds = item.destinationWell && item.destinationWell.engineerIds ? item.destinationWell.engineerIds : [];
            return sourceWellIds.concat(destWellIds).some(id => id === this.UserStore.user.id);
        }
        return false;
    }

    private getDateFromUnix = (unixDate: number, timezone: string) => {
        return moment.unix(unixDate).tz(timezone).format("MMM DD YYYY, h:mm a");
    }

    private getTestLink = (test:ITestApproval) => () => {
        const testUrl = `/well/${test.wellId}/test/${test.id}/welldata/testsetup`;
        return (
            <Link to={testUrl}>{this.getDateFromUnix(test.testDate, test.timeZoneName)}</Link>
        );
    }

    private getMudReportLink = (test: ITestApproval) => () => {
        const reportUrl = `/print/well/${test.wellId}/test/${test.id}/mudreportpdf`;
        return <Link to={reportUrl} target="_blank">Mud Report</Link>;
    }
    private approveTest = (testId:string) => (event:any) => {
        this.testsStore.approveTest(testId)
            .then((resp) => {
                this.refreshList();
            });
    }

    private rejectTest = (testId:string) => (event:any) => {
        this.testsStore.rejectTest(testId)
            .then((resp) => {
                this.refreshList();
            });
    }

    private approveDispatch = (dispatchId: string) => {
        const currDispatch = this.DispatchStore.dispatches.find(d => d.id === dispatchId);
        if (currDispatch) {
            this.DispatchStore.updateDispatchStatus(dispatchId, 
                {
                    comment: '',
                    estimatedArrival: currDispatch.estimatedArrival,
                    id: '',
                    requestedArrival: currDispatch.requestedArrival,
                    status: 'Approved',
                })
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Dispatch Approved.', 'success');
                        this.DispatchStore.getDispatches();
                    }
                });
        }
    }

    private rejectDispatch = (dispatchId: string) => {
        const currDispatch = this.DispatchStore.dispatches.find(d => d.id === dispatchId);
        if (currDispatch) {
            this.DispatchStore.updateDispatchStatus(dispatchId, 
                {
                    comment: '',
                    estimatedArrival: currDispatch.estimatedArrival,
                    id: '',
                    requestedArrival: currDispatch.requestedArrival,
                    status: 'Rejected',
                })
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Dispatch Rejected.', 'success');
                        this.DispatchStore.getDispatches();
                    }
                });
        }
    }

    // private approveProduct = (productId:string) => (event: any) => {
    //     this.AdminStore.approveProduct(productId)
    //         .then(resp => this.refreshProductList());
    // }

    // private rejectProduct = (productId:string) => (event: any) => {
    //     this.AdminStore.rejectProduct(productId)
    //         .then(resp => this.refreshProductList());
    // }
    
    private getApprovalRejectionButtons = (test: ITestApproval) => () => {
        return <ButtonGroup>
            <Button type="button" color="success" onClick={this.approveTest(test.id)}>Approve</Button>
            { test.testStatus !== 'Rejected' && <Button type="button" color="danger" onClick={this.rejectTest(test.id)}>Reject</Button>}
        </ButtonGroup>;
    }
    private createDataTable = ():IList => {
        const headerData = [
            'Well Name',
            'Test Report',
            'Test Date',
            'Current Interval',
            'Date Submitted',
            'Submitted By',
            'Status',
        ];

        if (this.UserStore.hasPermission('Permissions.WellTests.Approve.All')) {
            headerData.push('Approve/Reject');
        }

        const rows:any = [];

        this.state.approvalList.forEach((val) => {
            const tempRow: any = 
            [
                {
                    content: val.wellName
                },
                {
                    content: this.getMudReportLink(val),
                    sortItem: val.testDate,
                    type: 'render',
                },
                {
                    content: this.getTestLink(val),
                    sortItem: val.testDate,
                    type: 'render',
                },
                {
                    content: val.currentIntervalType,
                },
                {
                    content: this.getDateFromUnix(val.submittedForApproval, val.timeZoneName)
                },
                {
                    content: val.submittedForApprovalByUser
                },
                {
                    content: val.testStatus
                },
                
            ];
            if (this.UserStore.hasPermission('Permissions.WellTests.Approve.All')) {

                tempRow.push({
                    content: this.getApprovalRejectionButtons(val),
                    type: 'render'
                });
            }
                
            rows.push(tempRow);
        });
        return {
            headers: headerData,
            rows,
        };
    }

    // private handleEditProduct = (index: number) => {
    //     this.props.history.push(`/admin/products/${this.state.productApprovalList[index].id}`);
    // }

    // private createProductApproveReject = (product: IApprovalProduct) => () => {
    //     return <ButtonGroup>
    //             <Button type="button" color="success" onClick={this.approveProduct(product.id)}>Approve</Button>
    //             <Button type="button" color="danger" onClick={this.rejectProduct(product.id)}>Reject</Button>
    //         </ButtonGroup>;
    // }

    // private createDataTableProducts = ():IList => {
    //     const headerData = [
    //         'Product Name',
    //         'Category',
    //         'Size',
    //         'Unit',
    //         'Weight',
    //         'Specific Gravity',
    //         'Price',
    //         'Date Submitted',
    //         'Submitted By',
    //     ];

    //     if (this.UserStore.hasRoles('Admin')) {
    //         headerData.push('Approve/Reject');
    //     }
    //     const rows:any = [];

    //     this.state.productApprovalList.forEach(val => {
    //         const tempRow: any = [
    //             {
    //                 content: val.name
    //             },
    //             {
    //                 content: val.categorys[0].name
    //             },
    //             {
    //                 content: val.size
    //             },
    //             {
    //                 content: val.unit
    //             },
    //             {
    //                 content: val.weight
    //             },
    //             {
    //                 content: val.specificGravity
    //             },
    //             {
    //                 content: '$ ' + val.retailPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //             },
    //             {
    //                 content: val.createDate
    //             },
    //             {
    //                 content: val.createdBy
    //             },
    //         ];

    //         if (this.UserStore.hasRoles('Admin'))
    //         {
    //             tempRow.push({
    //                 content: this.createProductApproveReject(val),
    //                 type: 'render'
    //             });
    //         }
    //         rows.push(tempRow);
    //     });
    //     return {
    //         headers: headerData,
    //         rows,
    //     };
    // }

    public render() {
        return (
            <div>
                <Row>
                    <Col>
                        <h4 onClick={this.toggleApproval('tests')}>
                            <FontAwesomeIcon   
                                icon="chevron-right"
                                color={this.TenantStore.iconColor}
                                rotation={ this.state.showApprovals.tests ?
                                    90 : 270
                                }
                                transform="shrink-2"
                                style={{marginRight: '10px'}}
                            />
                            Tests Needing Approval
                        </h4>
                    </Col>
                </Row>
                { this.state.showApprovals.tests && 
                <DataTable
                    list={this.createDataTable()}
                />
                }
                {/* 
                    MUD-2025 Archive Product Approval
                <Row>
                    <Col>
                        <h4 style={{marginTop: '25px'}} onClick={this.toggleApproval('products')}>
                            <FontAwesomeIcon   
                                icon="chevron-right"
                                color={this.TenantStore.iconColor}
                                rotation={ this.state.showApprovals.products ?
                                    90 : 270
                                }
                                transform="shrink-2"
                                style={{marginRight: '10px'}}
                            />
                            Products Needing Approval
                        </h4>
                    </Col>
                </Row>
                {
                    this.state.showApprovals.products &&
                    <DataTable
                        list={this.createDataTableProducts()}
                        onEdit={this.UserStore.isAdmin() ? this.handleEditProduct : undefined}
                    />  
                }
            } */}
                <Row>
                    <Col>
                        <h4 style={{marginTop: '25px'}} onClick={this.toggleApproval('dispatches')}>
                            <FontAwesomeIcon   
                                icon="chevron-right"
                                color="#003a63"
                                rotation={ this.state.showApprovals.dispatches ?
                                    90 : 270
                                }
                                transform="shrink-2"
                                style={{marginRight: '10px'}}
                            />
                            Dispatches Needing Approval
                        </h4>
                    </Col>
                </Row>
                {
                    this.state.showApprovals.dispatches &&
                    <DispatchListTable 
                        dispatchList={this.DispatchStore.dispatches ? this.DispatchStore.dispatches.filter(this.filterNeedsApproval) : undefined}
                        showApprovalColumn={this.DispatchStore.dispatches ? this.DispatchStore.dispatches.filter(this.filterNeedsApproval).map(this.mapShowApproval) : []}
                        onApprove={this.approveDispatch}
                        onReject={this.rejectDispatch}
                        history={this.props.history}
                    />
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Main/Approval/Approval.tsx